// Guards against open redirects: only same-origin relative paths may be used
// as a post-login (or similar) navigation target. The value must start with a
// single slash, and — critically — is resolved through the URL parser before
// its origin is compared. That parser normalises exactly the way assigning
// `location.href` does: it strips ASCII tab/newline chars and treats `\` as
// `/`, so bypass tricks like `/%0A/evil.example` or `/\evil.example` (which
// browsers turn into `//evil.example`) resolve to an external origin and are
// rejected here, not just the literal `//` / `/\` prefixes.
export function isInternalRedirect(value: unknown): value is string {
  if (typeof value !== 'string' || !value.startsWith('/')) return false
  try {
    return (
      new URL(value, window.location.origin).origin === window.location.origin
    )
  } catch {
    return false
  }
}
